import { render, staticRenderFns } from "./IconLock.vue?vue&type=template&id=823bbef4&"
import script from "./IconLock.vue?vue&type=script&lang=js&"
export * from "./IconLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports